import { render, staticRenderFns } from "./kdxLazyImage.g.vue?vue&type=template&id=336ead5e&scoped=true"
import script from "./kdxLazyImage.g.vue?vue&type=script&lang=js"
export * from "./kdxLazyImage.g.vue?vue&type=script&lang=js"
import style0 from "./kdxLazyImage.g.vue?vue&type=style&index=0&id=336ead5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ead5e",
  null
  
)

export default component.exports